div<template>
  <div class="tabs-goods tabs-common">
    <div class="block_1" :style="detail ? 'display:none' : ''">
      <div class="d-flex justify-content-between align-items-center mb-4" v-if="show=='table'">
        <p class="common-title mb-0">List of Items</p>
        <button class="btn btn-success d-flex align-items-center" style="gap: 10px" @click.prevent="showAddProduct()">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2ZM0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10ZM10 5C10.5523 5 11 5.44772 11 6V9H14C14.5523 9 15 9.44771 15 10C15 10.5523 14.5523 11 14 11H11V14C11 14.5523 10.5523 15 10 15C9.44772 15 9 14.5523 9 14V11H6C5.44771 11 5 10.5523 5 10C5 9.44771 5.44771 9 6 9H9V6C9 5.44772 9.44771 5 10 5Z" fill="white"/></svg>
          Add
        </button>
      </div>
      <el-table v-if="show=='table'"
        :data="tab_data.sgd_goods"
        style="width: 100%"
        :header-cell-style="{
          background: '#EEEEEE',
          color: '#000000',
          border: '0px solid tan',
        }"
      >
        <el-table-column prop="item_no" label="#Item" width="65">
          <template slot-scope="scope">
            <div>
              {{ scope.row.item_no }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="hs_code" label="HS Code" width="110">
          <template slot-scope="scope">
            <div>
              {{ scope.row.hs_code.value }} | {{ scope.row.hs_code.display_text }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="good_name" label="Description of Goods" width="200">
          <template slot-scope="scope">
            <div>
              {{ scope.row.good_name }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="state_of_good" label="State of Goods">
          <template slot-scope="scope">
            <div>
              {{ scope.row.state_of_good }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="good_country" label="Country of Orgin">
          <template slot-scope="scope">
            <div>
              {{ (typeof scope.row.good_country === 'object'?scope.row.good_country.display_text:scope.row.good_country) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="sectoral_purpose" label="Sectoral Purpose">
          <template slot-scope="scope">
            <div>
              {{ scope.row.sectoral_purpose }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="net_weight" label="Net Weight">
          <template slot-scope="scope">
            <div>
              {{ scope.row.net_weight }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="fob_value" label="FOB Value" width="110">
          <template slot-scope="scope">
            <div>
              {{ scope.row.fob_value }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="freight_charges" label="Freight Charges">
          <template slot-scope="scope">
            <div>
              {{ scope.row.freight_charges }}
            </div>
          </template>
        </el-table-column>
        <el-table-column fixed="right" width="70">
          <template slot-scope="scope">
            <el-dropdown trigger="click" @command="$command => processDropdownCommand($command)">
              <button class="btn btn-link el-dropdown-link">
                <svg width="4" height="18" viewBox="0 0 4 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 2C4 3.10449 3.10455 4 2 4C0.895447 4 0 3.10449 0 2C0 0.895508 0.895447 0 2 0C3.10455 0 4 0.895508 4 2Z" fill="#8D8D8D"/><path d="M4 9C4 10.1045 3.10455 11 2 11C0.895447 11 0 10.1045 0 9C0 7.89551 0.895447 7 2 7C3.10455 7 4 7.89551 4 9Z" fill="#8D8D8D"/><path d="M2 18C3.10455 18 4 17.1045 4 16C4 14.8955 3.10455 14 2 14C0.895447 14 0 14.8955 0 16C0 17.1045 0.895447 18 2 18Z" fill="#8D8D8D"/></svg>
              </button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item class="dropdown-item" :command="{action: 'editProduct', index: scope.$index}"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M17.1106 4.31365C17.3196 4.1047 17.603 3.98731 17.8985 3.98731C18.0448 3.98731 18.1897 4.01613 18.3249 4.07212C18.4601 4.12812 18.5829 4.21019 18.6863 4.31365C18.7898 4.41711 18.8719 4.53994 18.9279 4.67512C18.9839 4.81031 19.0127 4.95519 19.0127 5.10151C19.0127 5.24783 18.9839 5.39272 18.9279 5.5279C18.8719 5.66308 18.7898 5.78591 18.6863 5.88937L8.45876 16.117L6.88304 14.5412L17.1106 4.31365ZM5.4778 15.9465L4.88456 16.5397L4.35932 18.6407L6.46029 18.1154L7.05352 17.5222L5.4778 15.9465ZM17.8985 2C17.0759 2 16.287 2.32677 15.7054 2.90841L3.28471 15.3291C3.15736 15.4564 3.06702 15.616 3.02334 15.7907L2.02969 19.7653C1.94504 20.1039 2.04425 20.4621 2.29106 20.7089C2.53786 20.9557 2.89606 21.055 3.23467 20.9703L7.20929 19.9767C7.384 19.933 7.54357 19.8426 7.67091 19.7153L20.0916 7.29461C20.3796 7.00661 20.608 6.6647 20.7639 6.28841C20.9198 5.91212 21 5.50881 21 5.10151C21 4.69422 20.9198 4.29091 20.7639 3.91462C20.608 3.53832 20.3796 3.19641 20.0916 2.90841C19.8036 2.62041 19.4617 2.39195 19.0854 2.23609C18.7091 2.08022 18.3058 2 17.8985 2Z" fill="#8D8D8D" fill-opacity="0.933333"/></svg> Edit</el-dropdown-item>
                <el-dropdown-item class="dropdown-item" :command="{action: 'removeProduct', index: scope.$index}"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M10 3C10 2.44772 10.4477 2 11 2H13C13.5523 2 14 2.44772 14 3V4H19C19.5523 4 20 4.44772 20 5C20 5.55228 19.5523 6 19 6H5C4.44772 6 4 5.55228 4 5C4 4.44772 4.44772 4 5 4H10V3ZM10 18C9.44772 18 9 17.5523 9 17L9 9C9 8.44772 9.44772 8 10 8C10.5523 8 11 8.44771 11 9V17C11 17.5523 10.5523 18 10 18ZM13 17C13 17.5523 13.4477 18 14 18C14.5523 18 15 17.5523 15 17V9C15 8.44771 14.5523 8 14 8C13.4477 8 13 8.44772 13 9V17ZM7 9C7 8.44772 6.55228 8 6 8C5.44772 8 5 8.44772 5 9V18C5 20.2091 6.79086 22 9 22H15C17.2091 22 19 20.2091 19 18V9C19 8.44772 18.5523 8 18 8C17.4477 8 17 8.44772 17 9V18C17 19.1046 16.1046 20 15 20H9C7.89543 20 7 19.1046 7 18V9Z" fill="#8D8D8D" fill-opacity="0.933333"/></svg> Delete</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="show=='add'">
        <add-product-form @add="$payload => addProduct($payload)" @cancel="cancelProduct()"/>
      </div>
      <div v-if="show=='edit'">
        <edit-product-form :index="current_item_index" :indata="current_item" @save="$payload => saveProduct($payload)" @cancel="cancelProduct()"/>
      </div>
    </div>
    <!-- <div class="foot_pagination" v-if="show=='table'">
      <img
        src="@/assets/chevron_left24.png"
        alt=""
        v-if="cur_tab_name != 'Header'"
        @click="page_change('Financial', 3)"
      />
      {{ cur_tab_name }}
      <img
        src="@/assets/chevron_right24.png"
        alt=""
        v-if="cur_tab_name != 'Support Information'"
        @click="page_change('Attachment', 5)"
      />
    </div> -->

    

    <el-dialog
      title="AI Search"
      :visible.sync="dialogVisible"
      width="40%"
    >
      <div>
        <el-form :model="form">
          <el-form-item>
            <el-input v-model="form.name" type="textarea" rows="5"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span class="dialog-footer">
        <el-button type="success" @click="showText" class="btns run"
          >Run</el-button
        >
        <el-button @click="dialogVisible = false" class="btns"
          >Cancel</el-button
        >
      </span>
      <div class="show_text" v-if="text">
        The HS code for Xigomi MiTV A2 43 is *85287280%. This code applies to
        "Televisions, whether or not Incorporating radio reception apparatus,
        having a screen of 43 inches (109 cm) or more ints greatest «diagonal
        length’. The Harmonized System (HS) isan international system of
        classification for traded ‘goods. itis used by customs authorities to
        classify goods and to determine the applicable import duties ‘and other
        trade regulations. The HS code for Xiaomi Mi TV A2 43 is specific to the
        43-inch model of this ‘TV. Other models of the Mi TV A2 may have
        different HS codes. | hope this helos! Let me know if you have any other
        questions. The HS code for Xigomi MiTV A2 43 is *85287280%. This code
        applies
      </div>
    </el-dialog>
  </div>
</template>

<script>
import common from "@/mixins/common-form-m";
import addProductForm from "./add-product-form.vue";
import editProductForm from "./edit-product-form.vue";

export default {
  name: "tabs-goods",
  props: ["cur_tab_name", 'indata'],
  components: {addProductForm, editProductForm},
  data() {
    return {
      detail: false,
      dialogVisible: false,
      show: 'table',
      current_item: {},
      current_item_index: -1,
      tab_data: {
        sgd_goods: []
      },
      tableData: [
      ],
      form: {
        name: "Placeholder",
      },
      text: false,
    };
  },
  mixins: [common],
  methods: {
    /**
     * Saves changes in the product
     * @param {*} param0 
     */
    saveProduct({good, index}){
      console.log(good, index)
      this.$set(this.tab_data.sgd_goods, index, good) 
      this.show = 'table'
      this.$emit('button', true)
    },
    /**
     * Is triggered by child add-product-form component, adds product to the list of products
     * @param {Object} payload 
     */
    addProduct(payload){
      this.tab_data.sgd_goods.push(payload)
      this.show = 'table'
      this.$emit('button', true)
    },
    /**
     * Shows add product form
     */
    showAddProduct(){
      this.show = 'add'
      this.$emit('button', false)
    },
    /**
     * Is triggered by product dropdown item click.
     * @param {Object} command 
     */
    processDropdownCommand(command){
      switch(command.action){
        case 'removeProduct': 
          this.$confirm('This will permanently delete the product. Continue?', 'Warning', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            type: 'warning'
          }).then(() => {
            this.tab_data.sgd_goods.splice(command.index, 1)
            this.$message({
              type: 'success',
              message: 'Delete completed'
            });
          }).catch(() => {
            this.$message({
              type: 'info',
              message: 'Delete canceled'
            });          
          });
          break;
        case 'editProduct': 
          this.current_item = this.tab_data.sgd_goods[command.index]
          this.current_item_index = command.index
          this.show = 'edit'
          this.$emit('button', false)
          break;
      }
    },
    /**
     * Removes product from the list
     * @param {Number} index 
     */
    removeProduct(index){
      this.$confirm('This will permanently delete the product. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete canceled'
        });          
      });
    },
    handleDetail() {
      this.detail = true;
    },
    handleClose() {
      this.detail = false;
    },
    handleOpen() {
      this.dialogVisible = true;
    },
    showText() {
      this.text = true;
    },
    beforeClose() {
      this.text = false;
      this.dialogVisible = false;
    },
    cancelProduct(){
      this.show = 'table'
      this.$emit('button', true)
    }
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.tabs-goods {
  /deep/ .el-table__body tr:hover > td {
    background-color: #cae4cb !important;
  }
  .dialog-footer {
    display: flex;
    flex-direction: row-reverse;
  }
  .show_text {
    height: 150px;
    overflow-y: scroll;
    margin-top: 20px;
  }
  ::-webkit-scrollbar {
    width: 5px;
    height: 8px;
    background-color: rgba(0, 0, 0, 0.2);
  }
  ::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #fff;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background-color: #dbdbdb;
  }
  .close {
    font-size: 30px;
    cursor: pointer;
    position: absolute;
    right: -50px;
  }
  .btns {
    width: 30%;
  }
  .run {
    margin-left: 20px;
    background-color: #488e53;
  }
  /deep/.el-dialog__title {
    color: #488e53;
    font-weight: 600;
  }
  .click {
    width: 50%;
    border: 1px #000 solid;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 35px;
    cursor: pointer;
  }
}

.btn.btn-success{
  background-color: #488E53 !important;
  border-color: #488E53 !important;
}
.dropdown-item{
  font-size: 16px !important;
  font-style: normal !important;
  font-weight: 400 !important;
  line-height: 24px !important;
  color: #333 !important;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
}

.el-dropdown-menu__item.dropdown-item:focus, .el-dropdown-menu__item.dropdown-item:not(.is-disabled):hover
{
  background-color: rgba(238, 238, 238, 0.93);
  color: #333 !important;
}

</style>
